import { Badge } from "@dl/web-core-js/ui";
import { useTranslation } from "react-i18next";
import type { StockCountStatus } from "../../api/stockCount";

/** A count sheet's status: blue while being counted, green once posted, grey if cancelled. */
export function StockCountStatusBadge({ status }: { status: StockCountStatus }) {
  const { t } = useTranslation();
  const variant = { OPEN: "info", POSTED: "success", CANCELLED: "neutral" } as const;
  return (
    <Badge variant={variant[status]} size="sm">
      {stockCountStatusLabel(t, status)}
    </Badge>
  );
}

export function stockCountStatusLabel(t: (key: string, fallback: string) => string, status: StockCountStatus): string {
  return {
    OPEN: t("count.status.open", "Open"),
    POSTED: t("count.status.posted", "Posted"),
    CANCELLED: t("count.status.cancelled", "Cancelled"),
  }[status];
}
